import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

import { ATOMS } from "../../recoil/atom";
import { IVersionCanal } from "../../types/versions";
import { createSnackBarContent } from "../global/useSnackBar";
import { fireDatabase } from "../../config/firebase";
import { needRequestCollections } from "../../constants/access";
import useNeedRequestVisibilityHelper from "../data/useNeedRequestVisibilityHelper";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

const collectionRequired = [needRequestCollections.VERSIONS];

const useVersionsCanalsList = () => {
  const { t } = useTranslation(["snackbar"]);

  const popSnackbar = useSetAtom(ATOMS.SNACKBAR);

  const setVersionsCanalsList = useSetAtom(ATOMS.VERSIONS_CANALS);

  const [unSubscribe, setUnSubscribe] = useState<(() => void) | null>(null);

  const canLoadData = useNeedRequestVisibilityHelper(() => {
    unSubscribe && unSubscribe();
  }, collectionRequired);

  // Versions canals list
  useEffect(() => {
    if (canLoadData) {
      const unsub = onSnapshot(
        collection(fireDatabase, "versions", "canals", "data"),
        (snap) => {
          const dataVersionsCanals: IVersionCanal[] = [];
          snap.docs.forEach((doc) => {
            const data = doc.data();
            if (data) {
              dataVersionsCanals.push(data as IVersionCanal);
            }
          });
          setVersionsCanalsList(dataVersionsCanals);
        },
        (err) => {
          console.error(err);
          popSnackbar(
            createSnackBarContent({
              content: t("snackbar:request_versions_canals_error"),
              severity: "error",
            }),
          );
          setVersionsCanalsList([]);
        },
      );

      setUnSubscribe(() => unsub);
      return () => unsub();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canLoadData]);

  return null;
};

export default useVersionsCanalsList;
